// extracted by mini-css-extract-plugin
module.exports = {"border":"FilterCheckList_border__juQuu"};